import { useTranslation } from 'next-i18next';
import React from 'react';

import { ArtistFiltersController } from '../../hooks/useArtistFilters';
import { ArtistCategoryFilter, MediumFilter } from '../../types/Filters';
import {
  TrackAllFiltersCleared,
  TrackFilterCleared,
} from '../../utils/analytics';
import { FilterBadge } from './FilterBadge';
import FilterBar from './FilterBar';

type Props = {
  className?: string;
  filters: ArtistFiltersController;
};

const ArtistFiltersBar: React.FC<Props> = ({ className, filters }) => {
  const { t } = useTranslation('filters');

  return (
    <FilterBar
      className={className}
      onClear={() => {
        filters.clearAll();

        TrackAllFiltersCleared({
          page: 'artists index',
          location: 'filter bar',
        });
      }}
    >
      {filters.categories.values.map((value) => (
        <FilterBadge
          label={t(CATEGORY_TRANSLATIONS[value])}
          onRemove={() => {
            filters.categories.remove(value);
            TrackFilterCleared({
              page: 'artists index',
              filterLabel: t(CATEGORY_TRANSLATIONS[value]),
            });
          }}
        />
      ))}

      {filters.mediums.values.map((value) => (
        <FilterBadge
          label={t(MEDIUM_TRANSLATIONS[value])}
          onRemove={() => {
            filters.mediums.remove(value);
            TrackFilterCleared({
              page: 'artists index',
              filterLabel: t(MEDIUM_TRANSLATIONS[value]),
            });
          }}
        />
      ))}
    </FilterBar>
  );
};

export default ArtistFiltersBar;

const CATEGORY_TRANSLATIONS: Record<ArtistCategoryFilter, string> = {
  'All': 'artists.categoryAll',
  'Upcoming': 'artists.categoryUpcoming',
  'Available': 'artists.categoryAvailable',
};

const MEDIUM_TRANSLATIONS: Record<MediumFilter, string> = {
  'All': 'artists.mediumAll',
  'Collectibles': 'artists.mediumCollectibles',
  'NFTs': 'artists.mediumNFT',
  'Print editions': 'artists.mediumPrints',
  'Sculpture editions': 'artists.mediumSculptures',
  'Studio works': 'artists.mediumStudioWorks',
};
